import React, { useState, useEffect, useRef } from 'react';
import {Sigla} from '../Sigla'
import './styles.scss'
import * as S from './styles'

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';
import 'swiper/components/scrollbar/scrollbar.scss';

// import Swiper core and required modules
import SwiperCore, {
    Pagination,Navigation,Autoplay
} from 'swiper/core';

import {v4 as uuidv4} from 'uuid'

// install Swiper modules
SwiperCore.use([Pagination,Navigation,Autoplay]);

type Props = {
    reportes: object[]
    size: number
}

export default function Carousel({ reportes, size } : Props) {
    const [children, setChildren] = useState([])
    const swiperRef = useRef(null)
    const slidesPerView = 3

    const create_siglas = () => {
        var children_array;
        if (swiperRef!==null && swiperRef.current!==null && 'swiper' in swiperRef.current) {
            //TODO: reduce retirando duplicatas
            children_array = reportes.map((r, idx) =>
                <SwiperSlide key={idx} virtualIndex={idx}>
                    <Sigla
                        key={uuidv4()}
                        requer_atencao={r.requer_atencao}
                        reporte_obrigatorio={r.reporte_obrigatorio}
                        size={size}
                    >
                        {r.sigla_departamento}
                    </Sigla>
                </SwiperSlide>
            )

            //pad de objetos ao array de children
            for (var i=children_array.length; i<slidesPerView; i++) { //breakpoints[swiperRef.current.swiper.currentBreakpoint].slidesPerView; i++) {
                children_array.unshift(
                    <SwiperSlide key={uuidv4()} virtualIndex={-i}/>
                )
            }
            setChildren(children_array)
        }
    }

    useEffect(() => {
        if (swiperRef!==null) {
            if (reportes.length<=slidesPerView ){ //breakpoints[swiperRef.current.swiper.currentBreakpoint].slidesPerView) {
                swiperRef.current.swiper.autoplay.stop()
            } else {
                swiperRef.current.swiper.autoplay.start()
            }
        }
        create_siglas()
    },[]) // eslint-disable-line

    return (
        <S.Container key={uuidv4()} className="carousel">
             <Swiper
                ref={swiperRef}
                slidesPerView={slidesPerView}
                spaceBetween={1}
                autoplay={{
                    "delay": 5000,
                    "disableOnInteraction": false
                  }}
                scrollbar={{ draggable: true }}
                observer={true}
                className="mySwiper"
                >
                {children}
            </Swiper>
        </S.Container>
    )
}
